import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Checkbox, Select, Radio } from 'react-daisyui';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ExportResponsesSPSSModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: (data: any) => void;
  selectedData?: Set<any>; // optional
  title?: string;  // optional
  content?: React.ReactNode;  // optional
  showInfoAlert?: string; // optional
}

const ExportResponsesSPSSModal: React.FC<ExportResponsesSPSSModalProps> = ({
  isOpen,
  onClose,
  onAction,
  title = 'Confirm Modal', // Default value for title
  showInfoAlert,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>('complete');

  // Wraps the action and resolves if its async or if its sync
  const onActionWrapper = (onAction: (data: any) => void) =>{
    setLoading(true);
    Promise.resolve(onAction(selectedOption)).catch((e)=>{
      toast.error(`Unknown error completing the action. ${e}`)
      setLoading(true);
    })
  }

  useEffect(() => {
    isOpen && setLoading(false);
  }, [isOpen]);

  return (
    <Modal open={isOpen}>
      <Modal.Header className="text-2xl font-bold">{title}</Modal.Header>
      <Modal.Body>
          <Form className="w-128">
          <h1 className=' font-bold mb-5'>Please select the options for the SPSS export.</h1>
          <Form.Label title="Complete">
            <Radio name="radio1" id={`exportResponseSPSSModalCompleteRadio`}  onChange={(e)=>setSelectedOption('complete')}/>
          </Form.Label>
          <Form.Label title="Incomplete">
            <Radio name="radio1" id={`exportResponseSPSSModalIncompleteRadio`} onChange={(e)=>setSelectedOption('incomplete')}/>
          </Form.Label>
          <Form.Label title="All">
            <Radio name="radio1" id={`exportResponseSPSSModalAllRadio`} onChange={(e)=>setSelectedOption('all')}/>
          </Form.Label>
        </Form>
        {loading && showInfoAlert && <p className='my-3'>
          <div role="alert" className="alert alert-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="h-6 w-6 shrink-0 stroke-current">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>{showInfoAlert}</span>
          </div></p>}
      </Modal.Body>

      <Modal.Actions>
        <Button id='ExportResponsesSPSSModalCancelButton' type="button" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button
           id='ExportResponsesSPSSModalConfrimButton'
          type="button"
          color="primary"
          className={loading ? 'pointer-events-none' : ''}
          onClick={loading ? undefined : () => onActionWrapper(onAction)}
        >
          {loading  ? (
            <div className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Loading...
            </div>
          ) : (
            'Confirm'
          )}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ExportResponsesSPSSModal;
